module.exports = __webpack_public_path__ + "static/browse_header-b4ecb584ed5725751c041a4f118776a3.png";